import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Sigma class
import Alexios_Kontothanassis from '../../media/Brothers/Headshots/Sigma/Alexios_Kontothanassis.jpg';
import Charlotte_Harper from '../../media/Brothers/Headshots/Sigma/Charlotte_Harper.jpg';
import Daniel_Su from '../../media/Brothers/Headshots/Sigma/Daniel_Su.jpg';
import Max_Kohl from '../../media/Brothers/Headshots/Sigma/Max_Kohl.jpg';
import Victoria_Wang from '../../media/Brothers/Headshots/Sigma/Victoria_Wang.jpg';




const Sigma = () => {
  const sigmaClass = [
    {broname: "Alexios Kontothanassis", src: Alexios_Kontothanassis, alt: "Alexios Kontothanassis", majorGrad: "Computer Engineering '27"},
    {broname: "Charlotte Harper", src: Charlotte_Harper, alt: "Charlotte Harper", majorGrad: "Mechanical Engineering '27"},
    {broname: "Daniel Su", src: Daniel_Su, alt: "Daniel Su", majorGrad: "Mechanical Engineering '27"},
    {broname: "Max Kohl", src: Max_Kohl, alt: "Max Kohl", majorGrad: "Mechanical Engineering '27"},
    {broname: "Victoria Wang", src: Victoria_Wang, alt: "Victoria Wang", majorGrad: "Mechanical Engineering '27"},
  ];
  return (
    <div className = "Classes">
      {sigmaClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Sigma;